import { Save, Loader2, Headphones } from 'lucide-react';
import { useEmpresaConfig } from '../../../../hooks/useEmpresaConfig';

export function HorarioSuporte() {
  const { empresa, setEmpresa, isLoading, isSaving, message, saveEmpresa } = useEmpresaConfig();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (empresa) saveEmpresa(empresa);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-8 h-8 text-brand animate-spin" />
      </div>
    );
  }

  if (!empresa) return null;

  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-3xl">
      {message && (
        <div className={`p-4 rounded-lg ${message.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
          {message.text}
        </div>
      )}

      <div className="bg-card border rounded-lg p-6">
        <h3 className="font-semibold text-foreground border-b pb-2 mb-4 flex items-center gap-2">
          <Headphones className="w-5 h-5 text-green-600" />
          Horário de Suporte
        </h3>
        <p className="text-sm text-muted-foreground mb-6">
          Define o intervalo em que o indicador <strong>Suporte Ativo</strong> pulsa no Portal do Cliente.
          Fora desse intervalo ele aparece como inativo. Deixe vazio para manter sempre ativo (24h).
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Início (HH:MM)</label>
            <input type="time" value={empresa.suporteInicio || ''} onChange={e => setEmpresa({ ...empresa, suporteInicio: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Fim (HH:MM)</label>
            <input type="time" value={empresa.suporteFim || ''} onChange={e => setEmpresa({ ...empresa, suporteFim: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <button type="submit" disabled={isSaving} className="flex items-center gap-2 px-6 py-2 btn btn-primary disabled:opacity-50">
          {isSaving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Salvar Configurações
        </button>
      </div>
    </form>
  );
}
